import req from './../../../fetch';
import { paramsToString, undocumentedResponse } from './../../../utils';
import {
  AllAPIResponses,
  CurrentValueType,
  CarbonError,
} from './../../../index';

type Params = {
  limit?: number;
  nodeId?: number[];
  offset?: number;
  raw?: boolean;
  uniqueId?: number[];
};

const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<CurrentValueType>> => {
  try {
    const resp = await req.get(
      `/api/data/current${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as CurrentValueType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
